import { Card, CardContent, CardHeader, CardTitle } from '@lensora/ui'
import { ShieldAlert } from 'lucide-react'

export function LookerInstructionsCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Connect Looker Studio</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm text-text">
        <ol className="list-inside list-decimal space-y-2 text-text-muted">
          <li>Create a key below and copy the secret shown — it's only displayed once.</li>
          <li>
            Open the Lensora Looker Studio connector and paste the secret into its
            <span className="font-medium text-text"> API Key</span> auth field.
          </li>
          <li>Add the connector as a data source to any Looker Studio report.</li>
        </ol>

        <div className="flex items-start gap-2.5 rounded-md border border-feedback-warning/30 bg-feedback-warning/5 p-3">
          <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0 text-feedback-warning" />
          <p className="text-xs text-text">
            The connector must send this key as an{' '}
            <code className="rounded bg-surface-raised px-1 py-0.5 text-[11px]">Authorization: Bearer &lt;key&gt;</code>{' '}
            header — never as a URL query parameter. A key placed in a query string ends up in
            server access logs and can leak to anyone with log access.
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
